export const Month = { validate: /^(([1-9])|(0[1-9])|(1[1-2]))$/, input: /^(([0-9])|(0[1-9])|(1[1-2]))$/ };
export const MonthDate = { validate: /^(([1-9])|(0[1-9])|([1-2][0-9])|(3[0-1]))$/, input: /^(([0-9])|(0[1-9])|([1-2][0-9])|(3[0-1]))$/ };
export const AreaCode = { validate: /^[0-9]{3}$/, input: /^[0-9]{0,3}$/ };
export const Email = { validate: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ };
export const Numeric = { validate: /^\d*$/ };